import { Box, Typography } from "@mui/material"

const LogoutPage = () => {
    return (
        <Box display="grid" justifyContent={"center"}>
            <Typography variant="h6" color="gray">ログアウトしました。</Typography>
            <Box display="grid" justifyContent={"center"} paddingTop={3} color="gray">
                {/* <Typography marginY={1}>新規お申し込みの方は<Link href="/request/" component={"a"}>こちら</Link></Typography> */}
            </Box>
        </Box>
    )
}

export default LogoutPage